import { Container, IDestroyOptions, Point, Texture } from "pixi.js";
import { CoinsCollectAnimationView } from "./CoinsCollectAnimationView";
import { RewardContainer } from "../RewardContainer";
import { gsap } from "gsap";
import { SlowMo } from "gsap/EasePack";
import { CommonResourcesPackage } from "../../resources/CommonResourcesPackage";

export class WinCoinsAnimation extends Container {
    private static readonly MOVE_REWARD_DURATION: number = 1;
    private static readonly REWARD_SCALE: number = 1.5;

    private coinsCollectAnimation: CoinsCollectAnimationView;
    private coinsReward: RewardContainer;
    private collectPoint: Point;
    private animation: gsap.core.Timeline;

    public constructor(
        commonResources: CommonResourcesPackage,
        rewardIcon: Texture,
        collectPoint: Point,
        rewardValue: number,
        collectItemsCount: number = 15
    ) {
        super();
        this.collectPoint = collectPoint;
        this.coinsCollectAnimation = new CoinsCollectAnimationView(commonResources, collectItemsCount, collectPoint);
        this.addChild(this.coinsCollectAnimation);
        this.coinsReward = new RewardContainer(rewardIcon, rewardValue);
        this.coinsReward.scale.set(WinCoinsAnimation.REWARD_SCALE, WinCoinsAnimation.REWARD_SCALE);
        this.coinsReward.position.x = this.coinsReward.width;
        this.addChild(this.coinsReward);
    }

    public async startAnimation(): Promise<void> {
        this.animation = new gsap.core.Timeline();
        this.coinsReward.alpha = 0;
        this.animation.to(this.coinsReward, { y: this.collectPoint.y * 0.75, duration: WinCoinsAnimation.MOVE_REWARD_DURATION, ease: "none" });
        this.animation.to(this.coinsReward,
            {
                alpha: 1,
                duration: WinCoinsAnimation.MOVE_REWARD_DURATION,
                ease: SlowMo.ease.config(0.5, 0.7, true)
            }, "<");
        this.animation.then(() => {
            this.animation.clear();
        });
        await this.coinsCollectAnimation.startAnimation();
    }

    override destroy(options?: boolean | IDestroyOptions): void {
        this.animation?.kill();
        super.destroy(options);
    }
}
